import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

export default function PlainPageLayout() {
  return (
    <div className="plain-layout mt-5 pb-5">
      <Container>
        <Outlet />
      </Container>
    </div>
  );
}
